import { privateRequest, type ApiResponse } from "../axios";
import { saveAsExcelFile } from "../excelService/excelSevice";

const ENDPOINTS = {
    MY_ORDER: "api/CRM/Orders",
    ORDER_STATUS: (orderId: number | string) => `api/CRM/Order/${orderId}/Status`,
    History: (orderId: number | string) => `api/CRM/Order/${orderId}/History`,
    GET_PDF: (orderId: number | string) => `api/CRM/Order/${orderId}/GetPdf`,
    EXPORT_EXCEL: "api/CRM/Orders/Export",
    NEXT_LEAD_TYPE: "api/CRM/LeadsByNextLeadType",
    ADDRESS: "api/AddressByLatLong",
    UPDATE_ORDER: "api/CRM/EditOrder",
    ORDER_DETAIL: "api/CRM/OrderDetail",
    ORDER_STATUS_DETAIL: (orderId: number | string) => `api/CRM/Order/${orderId}/Detail/Status`,
    ORDER_DETAIL_ROW: (orderId: number | string) => `api/CRM/Order/${orderId}/Detail`,
    GET_ORDERS_SETTINGS: "api/CRM/GetOrderSettings",
    SET_ORDERS_SETTINGS: "api/CRM/SetOrderSettings"
}

const Orders = async (data: any): Promise<ApiResponse<any>> => {
    const query = new URLSearchParams({
        From: data.from,
        To: data.to,
        StatusIds: data.statusIds.join(","),
        Text: data.text,
        UserIds: data.userIds.join(","),
        fromDate: data.fromDate,
        toDate: data.toDate,
        minOrderAmount: data.minOrderAmount,
        maxOrderAmount: data.maxOrderAmount,
        CountryId: data.countryId,
        StateId: data.stateId,
        CityId: data.cityId,
    }).toString();
    const res = await privateRequest.get<ApiResponse<any>>(
        `${ENDPOINTS.MY_ORDER}?${query}`
    )
    return res.data;
}
const Status = async (data: any): Promise<ApiResponse<any>> => {

    const res = await privateRequest.post<ApiResponse<any>>(
        `${ENDPOINTS.ORDER_STATUS(data.OrderId)}`, data
    );
    return res.data;
}
const History = async (data: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(
        `${ENDPOINTS.History(data.OrderId)}`, data
    );
    return res.data;
}
const GetPdf = async (data: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(
        `${ENDPOINTS.GET_PDF(data.OrderId)}`,
    )
    return res.data;
}
const LeadsByNextLeadType = async (data: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(
        `${ENDPOINTS.NEXT_LEAD_TYPE}`, data
    )
    return res.data;
}
const AddressByLatLong = async (data: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(
        `${ENDPOINTS.ADDRESS}?latitude=${data.lat}&longitude=${data.lng}`
    )
    return res.data;
}
const UpdateOrder = async (data: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(
        `${ENDPOINTS.UPDATE_ORDER}`,
        data
    );
    return res.data;
};

const OrderDetail = async (data: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(
        `${ENDPOINTS.ORDER_DETAIL}?orderId=${data.OrderId}`, data
    )
    return res.data
}
const DetailStatus = async (data: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(
        `${ENDPOINTS.ORDER_STATUS_DETAIL(data.OrderDetailId)}`, data
    )
    return res.data
}

const OrderDetailRow = async (data: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(
        `${ENDPOINTS.ORDER_DETAIL_ROW(data.OrderDetailId)}`, data
    )
    return res.data
}
const ExportExcel = async (data: any) => {

    const query = new URLSearchParams({
        From: data.from,
        To: data.to,
        StatusIds: data.statusIds.join(","),
        Text: data.text,
        UserIds: data.userIds.join(","),
        fromDate: data.fromDate,
        toDate: data.toDate,
        minOrderAmount: data.minOrderAmount,
        maxOrderAmount: data.maxOrderAmount,
        countryId: data.countryId,
        stateId: data.stateId,
        cityId: data.cityId
    }).toString();

    const res = await privateRequest.get<ApiResponse<any>>(
        `${ENDPOINTS.EXPORT_EXCEL}?${query}`
        , {
            responseType: "arraybuffer"
        }
    )   
    saveAsExcelFile(res,"Orders");
}

// ORDER SETTINGS
const getOrderSettings = async (): Promise<any> => {
    const response = await privateRequest.get<ApiResponse<any>>(`${ENDPOINTS.GET_ORDERS_SETTINGS}`);
    return response.data;
}

const setOrderSettings = async (payload: any): Promise<any> => {
    const response = await privateRequest.post<ApiResponse<any>>(`${ENDPOINTS.SET_ORDERS_SETTINGS}`, payload);
    return response.data;
}

const OrderService = {
    Orders,
    Status,
    History,
    GetPdf,
    LeadsByNextLeadType,
    AddressByLatLong,
    UpdateOrder,
    OrderDetail,
    DetailStatus,
    OrderDetailRow,
    ExportExcel,
    getOrderSettings,
    setOrderSettings
}

export default OrderService;